import axios from 'axios';

const configRequest = () => ({ withCredentials: true });

export default class Klickart {
  constructor() {
    this.axios = axios.create({ baseURL: process.env.KLICKART_URL });
  }

  get(resource = '', config = {}) {
    return this.axios.get(`/${resource}`, Object.assign({}, configRequest(), config));
  }

  put(resource = '', data, config = {}) {
    return this.axios.put(`/${resource}`, data, Object.assign({}, configRequest(), config));
  }

  post(resource = '', data, config = {}) {
    return this.axios.post(`/${resource}`, data, Object.assign({}, configRequest(), config));
  }

  delete(resource = '', config = {}) {
    return this.axios.delete(`/${resource}`, Object.assign({}, configRequest(), config));
  }
}



// WEBPACK FOOTER //
// ./src/services/request/klickart.js